import { render, staticRenderFns } from "./device485Manage.vue?vue&type=template&id=885ec422&"
import script from "./device485Manage.vue?vue&type=script&lang=js&"
export * from "./device485Manage.vue?vue&type=script&lang=js&"
import style0 from "./device485Manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports